export type ProfileCompletionInput = {
    firstName?: string;
    name?: string;
    qualification?: string;
    status?: string;
    careerAmbition?: string;
    skills?: string[];
    headline?: string;
    location?: string;
    photoURL?: string;
};

export type ProfileCompletionResult = {
    percent: number;
    completed: number;
    total: number;
    missing: string[];
};

const present = (value?: string) => Boolean(value?.trim());

export function profileCompletion(profile: ProfileCompletionInput): ProfileCompletionResult {
    const checks = [
        { label: "Name", complete: present(profile.firstName || profile.name) },
        { label: "Qualification", complete: present(profile.qualification) },
        { label: "Education status", complete: present(profile.status) },
        { label: "Career objective", complete: present(profile.careerAmbition) },
        { label: "Skills", complete: Boolean(profile.skills?.length) },
        { label: "Professional headline", complete: present(profile.headline) },
        { label: "Current location", complete: present(profile.location) },
        { label: "Profile photo", complete: present(profile.photoURL) },
    ];
    const completed = checks.filter((check) => check.complete).length;
    return { percent: Math.round((completed / checks.length) * 100), completed, total: checks.length, missing: checks.filter((check) => !check.complete).map((check) => check.label) };
}
